/**
 * @class
 * @description This class connect to cdn the cdb balancer api and hepls to get data
 * @exports CDNSelectorBusinessObject
 */
import { SwitchMethod } from '../Utils/Constants';
export default class CDNSelectorBusinessObject {
    constructor(cdnList, bandwidthThreshold, highetsSegmentBandwidth, activeSwitching) {
        this._cdnList = cdnList;
        this._activeSwitching = activeSwitching;
        this._bandwidthThreshold = bandwidthThreshold;
        this._highetsSegmentBandwidth = highetsSegmentBandwidth;
    }
    getCDN(segment) {
        let selectedCDN = 'Original';
        let cdnCandidates = new Map();
        // Discard banned and unactive candidates
        this._cdnList.forEach(function (value, key) {
            if (!value.banned && value.active) {
                //  debugger;
                cdnCandidates.set(key, value);
            }
        });
        cdnCandidates.delete('Original');
        if (cdnCandidates.size == 0) {
            return "Original";
        }
        if (cdnCandidates.size == 1) {
            return Array.from(cdnCandidates.keys())[0];
        }
        if (this._cdnList.size > 0) {
            if (this._activeSwitching) {
                switch (this._activeSwitching) {
                    case SwitchMethod.qualityPriority:
                        selectedCDN = this._qualityPriority(segment, cdnCandidates);
                        break;
                    case SwitchMethod.cdnPriority:
                        selectedCDN = this._cdnPriority(segment, cdnCandidates);
                        break;
                    case SwitchMethod.bestScore:
                        selectedCDN = this._bestScoredCdn(segment, cdnCandidates);
                        break;
                }
            }
            else {
                selectedCDN = this._bestScoredCdn(segment, cdnCandidates); // Just trust the API
            }
        }
        if (!selectedCDN || selectedCDN.trim() == '')
            return "Original";
        return selectedCDN;
    }
    /**
     * Using previous requests throughput and active requests count returns a CDN in proportion of their scores.
     * Prevents excess of parallel requests to the same CDN.
     * @returns {string} CDN name.
     * @private
     *
     *
     * Para sacarlo rapido seria, coger los CDN's con el bitrate mas alto que max bitrate de las renditions, y hacer el algoritmo ese que ya teniamos si quieres con los CDN's estos. ( Solo tener en cuenta los bandwidth de descarga de los segmentos del vidoe )
     * en caso de que ningun cdn de la talla nos quedariamos solo con el que va más rapido
     * sencillo y debería de más o menos funcionar
     *
     *
     */
    _qualityPriority(segment, cdnList) {
        var _a;
        const notUsedCdn = this._getNotUsedCdn();
        if (notUsedCdn) {
            return notUsedCdn;
        }
        let segmentBandwidth = ((_a = segment.rendition) === null || _a === void 0 ? void 0 : _a.bandwidth) || 0;
        if (segmentBandwidth == 0) {
            // Whe don't have data segment bandwidth data we can use information about the biggest segment 
        }
        let cdnFilteredList = new Map();
        // Discard CDN that don't have enought capacity
        let fastestCDNName = "";
        let fastestCDNBandwidth = 0;
        let cdnHighestRenditionBandwidth = 0;
        cdnList.forEach((cdn) => {
            // Best scored with a valid bandwidth
            let cdnReferenceBandwidth = cdn.getAvgLastVideoBandwidth(); /// (cdn.lastPreferedVideoBandwidth*8);
            // Bandwidth realtime prediction
            if (segment.rendition) {
                let value = cdn.calculateEffectiveBadnwidth(segment.rendition.bandwidth, segment.rendition.targetDuration);
                if (value != 0 && cdnReferenceBandwidth < value)
                    cdnReferenceBandwidth = value;
            }
            let testWithBigerChunks = false;
            if (segment.rendition != null && segment.rendition.bandwidth > (1.5 * cdn.highestRenditionBandwidth)) {
                testWithBigerChunks = true;
            }
            if (testWithBigerChunks || cdnReferenceBandwidth == 0 || this._highetsSegmentBandwidth == 0 || cdnReferenceBandwidth > this._highetsSegmentBandwidth) {
                cdnFilteredList.set(cdn.name, cdn);
            }
            if (fastestCDNBandwidth < cdn.getVideoBandwidth()) {
                fastestCDNBandwidth = cdn.getVideoBandwidth();
                fastestCDNName = cdn.name;
            }
        });
        if (cdnFilteredList.size == 0) {
            return fastestCDNName;
        }
        if (cdnFilteredList.size > 1) {
            cdnFilteredList.delete("Original");
        }
        // cambiar per el algoritme anterior
        let keys = Array.from(cdnFilteredList.keys());
        let randomKey = keys[Math.floor(Math.random() * (keys.length - 1))];
        return randomKey;
    }
    _getNotUsedCdn() {
        // eslint-disable-next-line
        let candidates = [];
        for (const [key, cdn] of this._cdnList) {
            if (cdn.active && !cdn.banned && !cdn.usedOnce) {
                candidates.push(cdn.name);
            }
        }
        if (candidates.length == 0)
            return undefined;
        let randPos = Math.floor(Math.random() * (candidates.length));
        let candidate = candidates[randPos];
        let candidateCDN = this._cdnList.get(candidate);
        if (candidateCDN != undefined) {
            candidateCDN.usedOnce = true;
        }
        return candidate;
    }
    /**
    * Uses always the first CDN of the list until its bandwidth is lower than the defined value, then uses following one as a fallback.
    * If no CDNs are valid, it reset the scores and uses the best scored by the API to start again.
    * @returns {string} CDN name.
    * @private
    */
    _cdnPriority(segment, cdnList) {
        let ret = '';
        let best = -1;
        this._cdnList.forEach((cdn) => {
            // Best scored with a valid bandwidth
            if (cdn.score > best && cdn.getBandwidth() > this._bandwidthThreshold && !segment.triedCdns.includes(cdn.name) && cdn.provider != 'ORIGINAL') {
                ret = cdn.name;
                best = cdn.score;
            }
        });
        // If no valid options, reset the scores and get the best scored (nonrecursive)
        if (ret === '') {
            this._cdnList.forEach((cdn) => {
                cdn.resetBandwidth();
            });
            ret = this._bestScoredCdn(segment, cdnList);
        }
        return ret;
    }
    /**
     * Returns always the CDN with the best score value provided by the API.
     * @returns {string} CDN name.
     * @private
     */
    _bestScoredCdn(segment, cdnList) {
        let ret = '';
        let best = -1;
        this._cdnList.forEach((cdn) => {
            if (cdn.score > best && !segment.triedCdns.includes(cdn.name) && cdn.provider != 'ORIGINAL') {
                ret = cdn.name;
                best = cdn.score;
            }
        });
        return ret;
    }
}
